import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openModal(event) {
    const brandId = event.currentTarget.dataset.brandId
    const brandName = event.currentTarget.dataset.brandName

    const form = document.getElementById('duplicate-form')
    if (form) {
      form.action = `/admin/brands/${brandId}/duplicate`
    }

    window.dispatchEvent(new CustomEvent('open-duplicate-modal', {
      detail: { brandId: brandId, brandName: brandName }
    }))
  }

  openEditModal(event) {
    const dataset = event.currentTarget.dataset
    const brandId = dataset.brandId

    const form = document.getElementById('edit-brand-form')
    if (form) {
      form.action = `/brands/${brandId}`
    }

    window.dispatchEvent(new CustomEvent('open-edit-modal', {
      detail: {
        brandId,
        brandName: dataset.brandName,
        brandUrl: dataset.brandUrl || '',
        brandCountry: dataset.brandCountry || '',
        brandCrueltyFree: dataset.brandCrueltyFree === 'true',
        brandSlug: dataset.brandSlug || ''
      }
    }))
  }
}
